var map = {
	"./alien_antennae.png": 7109,
	"./beret.png": 80994,
	"./black_bow.png": 23277,
	"./black_widow.png": 73913,
	"./blank.png": 88377,
	"./blood_candle.png": 58909,
	"./bloody_chef.png": 98397,
	"./blue_halo.png": 28646,
	"./bow.png": 27065,
	"./candle.png": 29687,
	"./caterpillar.png": 74973,
	"./caterpiller.png": 27327,
	"./chef.png": 74225,
	"./crown.png": 30869,
	"./crown_of_the_dead.png": 97546,
	"./demon_halo.png": 67884,
	"./devil_horns.png": 39116,
	"./dreadlocks.png": 9173,
	"./egg.png": 75862,
	"./emo.png": 58447,
	"./enlightenft_trucker.png": 45918,
	"./eth_is_dead_hat.png": 59643,
	"./fire.png": 7846,
	"./fireball.png": 12189,
	"./flamehawk.png": 71805,
	"./halo.png": 12839,
	"./iron_helmet.png": 25270,
	"./jack_o_lantern.png": 24353,
	"./jester_hat.png": 50657,
	"./killer_wasps.png": 67829,
	"./mohawk.png": 28941,
	"./mullet.png": 61008,
	"./none.png": 31849,
	"./pirate_hat.png": 62974,
	"./polygon_trucker.png": 26893,
	"./propeller_hat.png": 96981,
	"./red_horns.png": 25949,
	"./rose.png": 77060,
	"./rotten_egg.png": 23555,
	"./super_spikes.png": 3128,
	"./unicorn_horn.png": 59067,
	"./warrior_helmet.png": 46113,
	"./wizard_scar.png": 93407,
	"./zombie_unicorn.png": 47973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26420;